import { CustomersListComponent } from "./customers-list.component";
import { CustomersListModule } from "./customers-list.module";
import { RouterModule, Routes } from "@angular/router";
import { CustomerDetailsModule } from "../customer-details/customer-details.module";

const routes: Routes = [
    { path: '', component: CustomersListComponent },
    { path: 'customer', loadChildren: () => CustomerDetailsModule }
  ];

  export const CustomersListRouting = RouterModule.forChild(routes);